import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconWallet5: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconWallet5"><Path d="M21.5 9.5V4.5H2.5V19.5H21.5V14.5" stroke="currentColor"/><Path d="M22.5 9.5H14.5V14.5H22.5V9.5Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconWallet5;
